"use strict";

var _interopRequireWildcard = require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.array.sort.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

var _regeneratorRuntime2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/objectSpread2.js"));

var user = _interopRequireWildcard(require("@/api/user"));

var _vuex = require("vuex");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  props: {
    showAll: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      agency: {
        lv1: null,
        lv2: null,
        lv3: null,
        lv4: null
      },
      levels: {
        lv1: [],
        lv2: [],
        lv3: [],
        lv4: []
      },
      data: [],
      filterLevel2: [],
      filterLevel3: [],
      filterLevel4: []
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapState)({
    agencyLevel: function agencyLevel(state) {
      return state.user.agencyLevel;
    }
  })),
  created: function created() {
    this.getAgencyRoot();
  },
  methods: {
    handleChangeLevel1: function handleChangeLevel1() {
      var _this = this;

      this.agency.lv2 = null;
      this.agency.lv3 = null;
      this.agency.lv4 = null;

      if (this.agency.lv1 == "All") {
        this.filterLevel2 = this.levels.lv2;
        this.filterLevel3 = this.levels.lv3;
        this.filterLevel4 = this.levels.lv4;
      } else {
        var filterLevel2 = this.levels.lv2.filter(function (item) {
          return item.parentId == _this.agency.lv1;
        });
        this.filterLevel2 = filterLevel2;
        var filterLevel3 = this.levels.lv3.filter(function (lv3) {
          return _this.filterLevel2.some(function (lv2) {
            return lv3.parentId == lv2.id;
          });
        });
        this.filterLevel3 = filterLevel3;
        var filterLevel4 = this.levels.lv4.filter(function (lv4) {
          return _this.filterLevel3.some(function (lv3) {
            return lv4.parentId == lv3.id;
          });
        });
        this.filterLevel4 = filterLevel4;
      }
    },
    handleChangeLevel2: function handleChangeLevel2() {
      var _this2 = this;

      this.agency.lv3 = null;
      this.agency.lv4 = null;

      if (this.agency.lv2 == "All") {
        var filterLevel3 = this.levels.lv3.filter(function (lv3) {
          return _this2.filterLevel2.some(function (lv2) {
            return lv2.id == lv3.parentId;
          });
        });
        this.filterLevel3 = filterLevel3;
        var filterLevel4 = this.levels.lv4.filter(function (lv4) {
          return _this2.filterLevel3.some(function (lv3) {
            return lv4.parentId == lv3.id;
          });
        });
        this.filterLevel4 = filterLevel4;
      } else {
        var _filterLevel = this.levels.lv3.filter(function (lv3) {
          return lv3.parentId == _this2.agency.lv2;
        });

        this.filterLevel3 = _filterLevel;

        var _filterLevel2 = this.levels.lv4.filter(function (lv4) {
          return _this2.filterLevel3.some(function (lv3) {
            return lv4.parentId == lv3.id;
          });
        });

        this.filterLevel4 = _filterLevel2;
      }
    },
    handleChangeLevel3: function handleChangeLevel3() {
      var _this3 = this;

      this.agency.lv4 = null;

      if (this.agency.lv3 == "All") {
        var filterLevel4 = this.levels.lv4.filter(function (lv4) {
          return _this3.filterLevel3.some(function (lv3) {
            return lv4.parentId == lv3.id;
          });
        });
        this.filterLevel4 = filterLevel4;
      } else {
        var _filterLevel3 = this.levels.lv4.filter(function (lv4) {
          return lv4.parentId == _this3.agency.lv3;
        });

        this.filterLevel4 = _filterLevel3;
      }
    },
    getData: function getData() {
      return this.agency;
    },
    visibleAll: function visibleAll(level) {
      // debugger;
      // if (this.showAll) {
      //   return true;
      // }
      var userLevel = this.$store.state.user.agencyLevel;

      if (!userLevel) {
        return true;
      }

      return userLevel < level;
    },
    getAgencyRoot: function getAgencyRoot() {
      var _this4 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return user.getAllRootTree();

              case 2:
                res = _context.sent;
                res.data.sort(function (a, b) {
                  var nameA = a.name[0].toLowerCase();
                  var nameB = b.name[0].toLowerCase();

                  if (nameA < nameB) {
                    return -1;
                  }

                  if (nameA > nameB) {
                    return 1;
                  }

                  return 0;
                });
                res.data.forEach(function (element) {
                  _this4.levels["lv".concat(element.agencyLevelId)].push(element);
                });
                _this4.data = res.data;

                if (_this4.agencyLevel) {
                  Object.keys(_this4.levels).forEach(function (k) {
                    var level = k.split("lv")[1];

                    if (_this4.agencyLevel >= level && _this4.levels[k].length) {
                      _this4.$set(_this4.agency, k, _this4.levels[k][0].id);
                    }
                  });
                }

                _this4.filterLevel2 = _this4.levels.lv2.filter(function (item) {
                  return item.parentId == _this4.agency.lv1;
                });
                _this4.filterLevel3 = _this4.levels.lv3.filter(function (lv3) {
                  return _this4.filterLevel2.some(function (lv2) {
                    return lv3.parentId == lv2.id;
                  });
                });
                _this4.filterLevel4 = _this4.levels.lv4.filter(function (lv4) {
                  return _this4.filterLevel3.some(function (lv3) {
                    return lv4.parentId == lv3.id;
                  });
                });

                _this4.$emit("init:ok");

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};
exports.default = _default;